/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */

import IMG_BG from 'assets/images/SMSSentDialog.svg';
import { useTranslation } from 'providers/GILT.provider';

import PopupHeader from 'clientCommunications/components/Clients/ConfirmationModal/PopupHeader';

const NotSmsCreditDialog = ({
  isModalAction,
  history,
  expected_count,
  sms_credits_available,
  numClientsToBeSentOptout,
  openPurchaseModal,
}) => {
  const { t } = useTranslation();

  return (
    <div data-bem="NotSmsCreditDialog" className="dialog-container-marketing">
      <div className="popup-2-button animated zoomIn">
        <PopupHeader
          isModalAction={isModalAction}
          onClose={() => {}}
          history={history}
          style={{ background: `Url(${IMG_BG})`, height: '414px', borderRadius: '4px' }}
        >
          <div className="flex-center">
            <div className="modal-content">
              <div className="sms-title">
                <div>
                  {t('scheduler.smsButton.insufficientCredits', {
                    requiredCredits: expected_count,
                    availableCredits: sms_credits_available,
                  })}
                </div>
              </div>
              <p className="uniq-note">{t('scheduler.smsButton.purchaseMore')}</p>
              <p className="uniq-note text-smaller">
                {t('scheduler.smsButton.optOutMessage', {
                  numClients: numClientsToBeSentOptout,
                })}
              </p>
              <br />
            </div>
          </div>
        </PopupHeader>
        <div className="footer-marketing-sendsms cfix fromMarketing">
          <div className="marketing-button-container">
            <button className="sms-btn-white" style={{ marginRight: '46px' }}>
              {t('scheduler.smsButton.noThanks')}
            </button>
            <button className="sms-btn-violet" onClick={openPurchaseModal}>
              {t('scheduler.smsButton.getMoreCredits')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotSmsCreditDialog;
